<div class="layout-topbar">
	<div class="layout-topbar-left">
		<a class="app-name" href="/">
			<img alt="main logo" [src]="'assets/layout/images/logo-512.png'" class="app-logo" />
			<span>Admin Ubiq</span>
		</a>

		<a href="#" class="menu-button" (click)="appMain.onMenuButtonClick($event)">
			<div class="menu-button-icon"></div>
		</a>

		<ul class="layout-topbar-main-menu">
			<li>
				<a
					[routerLink]="['/accueil']"
					[routerLinkActiveOptions]="{ exact: true }"
					routerLinkActive="topbar-active-menuitem-routerlink"
					>{{ "menu.accueil" | translate }}
					<span class="active-bottom"></span>
				</a>
			</li>
			<!-- <li app-topmenu *ngFor="let item of menu; let i = index;" [item]="item" [index]="i" [root]="true" class="layout-topbar-menu" (click)="appMain.onTopbarMenuClick($event)"></li> -->
		</ul>
	</div>
	<div class="layout-topbar-right">
		<ul class="layout-topbar-actions">
			<li
				#profile
				class="profile-item"
				[ngClass]="{
					'active-topmenuitem fadeInDown': appMain.activeTopbarItem === profile
				}">
				<div class="profile-container" (click)="appMain.onTopbarItemClick($event, profile)">
					<a href="#">{{ initials }}</a>
					<div class="name-container">
						<span class="name">{{ username }}</span>
						<span class="job">{{ email }}</span>
					</div>
					<i class="pi pi-angle-down"></i>
				</div>

				<ul class="profile-menu fadeInDown">
					<li>
						<a class="cursor-pointer" (click)="onLogoutClick()">
							<span>{{ "topbar.deconnect" | translate }}</span>
						</a>
					</li>
				</ul>
			</li>
		</ul>
	</div>
</div>
